// extracted by mini-css-extract-plugin
export default {"questionContainer":"Question_questionContainer__yoCY+","questionWrapper":"Question_questionWrapper__q6N3f","answerWrapper":"Question_answerWrapper__aqHaf"};